import React from "react";

function ProductsCategory() {
  return (
    <>
      <section>
        <h1>
          <span className="page-title border-small">Our Products</span>
        </h1>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 col-6">
              <div className="img-wrap">
                <a href="/brasscomponents">
                  <img src={"../assets/img/brasscomponents-banner.jpg"} />
                </a>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="img-wrap">
                <a href="/pprinsertscomponents">
                  <img src={"../assets/img/ppr-inserts.jpg"} />
                </a>
              </div>
            </div>
            <div className="col-md-4 col-6">
              <div className="img-wrap">
                <img src={"../assets/img/brasscomponents-banner.jpg"} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProductsCategory;
